class CorporateGiftingForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
    });
    fetch("https://submit-form.com/hgtJBMnB", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body,
    })
      .then(function (response) {
        document.querySelector(
          ".component--corporate-gifting--form"
        ).style.display = "none";
        document.querySelector(
          ".component--corporate-gifting--form__success-message"
        ).style.display = "block";
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(() => {
        submitButton.removeAttribute("disabled");
      });
  }
}
customElements.define("corporate-gifting-form", CorporateGiftingForm);
